import React, { useEffect, useState } from 'react'
import {
  Button,
  PageHeader,
  Form,
  Input,
  Row,
  Col,
  notification,
  Spin,
  Card,
  Table,
  Modal,
} from 'antd'
import {
  getProductFabric,
  updateProductFabric,
} from '../../network/ProductFabrics'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

const EditProductFabric = ({ history }) => {
  const { key } = useParams()
  const { user } = useAuth()
  const [loading, setLoading] = useState(true)
  const [productData, setProductData] = useState(null)
  const [fabrics, setFabrics] = useState([])
  const [form] = Form.useForm()

  useEffect(() => {
    setLoading(true)
    getProductFabric(key)
      .then((data) => {
        const product = data.product
        const fabricsList = data.product.fabrics || []

        if (product) {
          setProductData(product)
          setFabrics(fabricsList)
        } else {
          notification.error({ message: 'Product Fabric not found!' })
        }
        setLoading(false)
      })
      .catch((error) => {
        console.error('Failed to fetch product fabrics:', error)
        notification.error({ message: 'Error fetching product fabrics!' })
        setLoading(false)
      })
  }, [key])

  const handleAddFabric = () => {
    const newFabric = {
      key: `new_fabric_${Date.now()}`,
      label: '',
    }

    setFabrics([newFabric, ...fabrics])
  }

  const handleRemoveFabric = (fabricToRemove) => {
    Modal.confirm({
      title: 'Confirm Delete',
      content: `Are you sure you want to delete the fabric "${
        fabricToRemove.label || fabricToRemove.key
      }"?`,
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        const newFabrics = fabrics.filter((f) => f.key !== fabricToRemove.key)
        setFabrics(newFabrics)
        notification.success({ message: 'Fabric deleted successfully!' })
      },
    })
  }

  const handleSave = async () => {
    try {
      const values = await form.validateFields()

      const updatedFabrics = fabrics.map((fabric) => {
        const newKey = values[`fabric_key_${fabric.key}`] || fabric.key
        const newLabel = values[`fabric_label_${fabric.key}`] || fabric.label

        return {
          key: newKey,
          label: newLabel,
        }
      })

      console.log('Updated fabrics:', updatedFabrics)

      updateProductFabric(user.currentStore, { [key]: updatedFabrics })
        .then(() => {
          notification.success({
            message: 'Product fabrics updated successfully!',
          })
          history.push('/product-fabrics')
        })
        .catch((error) => {
          console.error('Failed to update product fabrics:', error)
          notification.error({ message: 'Error updating product fabrics' })
        })

      setFabrics(updatedFabrics)
    } catch (error) {
      console.error('Validation failed:', error)
      notification.error({ message: 'Please fill in all required fields!' })
    }
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => history.push('/product-fabrics')}
        title={`Edit Fabrics for ${productData?.label || 'Product'}`}
        extra={[
          <Button key="save" type="primary" onClick={handleAddFabric}>
            Add Fabric
          </Button>,
        ]}
      />
      <Row style={{ padding: '24px' }}>
        <Col span={24}>
          <Card>
            <Form form={form} layout="vertical">
              <Table
                dataSource={fabrics.map((fabric, index) => ({
                  ...fabric,
                  index,
                }))}
                columns={[
                  {
                    title: 'Fabric Key',
                    dataIndex: 'key',
                    key: 'key',
                    width: '40%',
                    render: (text, record) => (
                      <Form.Item
                        name={`fabric_key_${record.key}`}
                        initialValue={text}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter fabric key!',
                          },
                        ]}
                        style={{ margin: 0 }}
                      >
                        <Input placeholder="Enter fabric key" />
                      </Form.Item>
                    ),
                  },
                  {
                    title: 'Fabric Label',
                    dataIndex: 'label',
                    key: 'label',
                    width: '40%',
                    render: (text, record) => (
                      <Form.Item
                        name={`fabric_label_${record.key}`}
                        initialValue={text}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter fabric name!',
                          },
                        ]}
                        style={{ margin: 0 }}
                      >
                        <Input placeholder="Enter fabric name" />
                      </Form.Item>
                    ),
                  },
                  {
                    title: 'Action',
                    key: 'action',
                    width: '20%',
                    render: (text, record) => (
                      <Button
                        type="link"
                        danger
                        onClick={() => handleRemoveFabric(record)}
                      >
                        Remove
                      </Button>
                    ),
                  },
                ]}
                pagination={false}
                rowKey="key"
                locale={{
                  emptyText: 'No fabrics available for this product.',
                }}
              />
            </Form>
            <Button
              style={{ marginTop: '20px' }}
              type="primary"
              onClick={handleSave}
            >
              Save Changes
            </Button>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default EditProductFabric
